import styled from 'styled-components';
import { CardHeader } from 'reactstrap';
import { Pie } from 'react-chartjs-2';

export const CardsItemWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50rem, 1fr));
  gap: 2rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const ProtocolInfoWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 4fr 2fr;
  grid-gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    & > :nth-child(2) {
      order: -1;
    }
  }
`;

// charts
export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: space-around;
`;

export const ChartCardHeaderContainer = styled(CardHeader)`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: 40rem) {
    text-align: center;
    justify-content: center;
  }

  @media screen and (min-width: 40.02rem) and (max-width: 64rem) {
    text-align: center;
    justify-content: center;
  }

  @media screen and (min-width: 64.02rem) and (max-width: 96rem) {
    justify-content: flex-start;
    align-self: baseline;
  }
`;

export const PieChartWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  ${Pie} {
    max-width: 20rem;
    transition: all 0.3s ease;
  }

  // Mobile screens (640px or less)
  @media screen and (max-width: 40rem) {
    width: 90%;

    ${Pie} {
      max-width: 14rem;
    }
  }

  // Tablet screens
  @media screen and (min-width: 40.063rem) and (max-width: 64rem) {
    ${Pie} {
      max-width: 15rem;
    }
  }
`;

export const CustomLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-height: 100px;
  overflow-y: auto;
  margin-bottom: 10px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin: 5px;
`;

export const LegendColor = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: ${(props) => props.color};
  margin-right: 5px;
  border-radius: 50%;
`;

export const LegendLabel = styled.span`
  font-size: 14px;
`;

export const ResponsiveFlexSelect = styled.div`
  .react-select__control {
    height: 38px !important;
    border: 1px solid #ced4da !important;
    border-radius: 0.375rem !important;
    box-shadow: none !important;
    background-color: #fff !important;
    font-size: 1rem !important;
    line-height: 1.5 !important;
    transition: all 0.15s ease-in-out !important;
    padding: 0 !important;
  }

  .react-select__control:hover {
    border-color: #adb5bd !important;
  }

  .react-select__control--is-focused {
    border-color: #80bdff !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
    outline: 0 !important;
  }

  .react-select__value-container {
    padding: 0 8px !important;
    height: 100% !important;
    display: flex !important;
    align-items: center !important;
  }

  .react-select__single-value,
  .react-select__placeholder {
    margin: 0 !important;
    color: #495057 !important;
    font-size: 1rem !important;
    line-height: 1.5 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .react-select__placeholder {
    color: #6c757d !important;
  }

  .react-select__indicator-separator {
    background-color: #ced4da !important;
    width: 1px !important;
    margin: 8px 0 !important;
  }

  .react-select__dropdown-indicator {
    color: #6c757d !important;
    padding: 8px !important;
  }

  .react-select__single-value,
  .react-select__placeholder,
  .react-select__option {
    font-size: 1rem !important;
  }

  @media (max-width: 1400px) {
    .react-select__single-value,
    .react-select__placeholder,
    .react-select__option {
      font-size: 0.875rem !important;
    }
  }

  @media (max-width: 1200px) {
    .react-select__single-value,
    .react-select__placeholder,
    .react-select__option {
      font-size: 0.8rem !important;
    }
  }

  @media (max-width: 992px) {
    .react-select__single-value,
    .react-select__placeholder,
    .react-select__option {
      font-size: 0.75rem !important;
    }
  }

  @media (max-width: 768px) {
    .react-select__single-value,
    .react-select__placeholder,
    .react-select__option {
      font-size: 0.7rem !important;
    }
  }
`;
